import { Box, styled } from "@mui/material";
import { MekiDocIcon as MekiDocIconComponent } from "@icons";

const MekiDocIcon = styled(MekiDocIconComponent)({
  width: "142px",
  height: "142px",
});

const Root = styled(Box)({
  backgroundColor: "white",
  display: "flex",
  flex: 1,
  justifyContent: "center",
  alignItems: "center",
});

export const MekiDocSplashScreen: React.FC = () => {
  return (
    <Root>
      <MekiDocIcon />
    </Root>
  );
};
